"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgaeBioreactors = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var MoonExpansion_1 = require("../../moon/MoonExpansion");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var MoonCard_1 = require("./MoonCard");
var AlgaeBioreactors = (function (_super) {
    __extends(AlgaeBioreactors, _super);
    function AlgaeBioreactors() {
        return _super.call(this, {
            name: CardName_1.CardName.ALGAE_BIOREACTORS,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.PLANT],
            cost: 9,
            productionBox: Units_1.Units.of({ plants: -1 }),
            tr: { moonColony: 1, oxygen: 1 },
            metadata: {
                description: 'Decrease your plant production 1 step. Raise the Colony Rate 1 step and oxygen 1%.',
                cardNumber: 'M47',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.minus().plants(1); }).moonColonyRate().oxygen(1);
                }),
            },
        }, {}) || this;
    }
    ;
    AlgaeBioreactors.prototype.play = function (player) {
        _super.prototype.play.call(this, player);
        MoonExpansion_1.MoonExpansion.raiseColonyRate(player);
        player.game.increaseOxygenLevel(player, 1);
        return undefined;
    };
    return AlgaeBioreactors;
}(MoonCard_1.MoonCard));
exports.AlgaeBioreactors = AlgaeBioreactors;
